<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="svg-icon">
    <path
      d="M5.38,16.66h8.7v1.72H4.73l-4-3.48V5.56L4.7,1.62h9.38V3.34H5.41L2.48,6.27v7.85ZM14.94,5.49l4.3,4.3-4.3,4.29V11H7.43V9.24h7.51Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
